<template>
  <div style="position: relative;" class="bg-white p-4">
    <div>
      <div class="d-flex align-items-center">
        <div>
          <h1 class="title">{{ $t("question-set.plural") }}</h1>
        </div>
      </div>
      <div class="d-flex justify-content-end" v-if="hasOrganizationQuestionSetViewPermission">
        <div  class="d-flex align-items-center" @click="$root.$emit('bv::toggle::collapse', `sidebar-add-question-set`)">
          <div class="new-task-text">{{ $t("question-set.new") }}</div>
          <div class="plus-button" style="margin-right: 1.56rem;"></div>
        </div>

        <!-- <sweet-button class="mr-4" @click="$root.$emit('bv::toggle::collapse', `sidebar-add-question-set`)"  variant="link" icon="bx bx-plus" size="sm" buttonClass=" text-white btn-main">
        {{ $t("question-set.add") }}
      </sweet-button> -->

      <!-- <sweet-button class="mr-4" @click="$root.$emit('bv::toggle::collapse', `sidebar-new-question-set`)"  variant="link" icon="bx bx-plus" size="sm" buttonClass=" text-white btn-main">
        {{ $t("question-set.new") }}
      </sweet-button> -->
      </div>

      <nav class="tab-menu">
        <div :class="{ active: activeTab === 'questionset' }" @click="activeTab = 'questionset'">
          {{ $t("question-set.pairs") }}
        </div>
        <div :class="{ active: activeTab === 'survey' }" @click="activeTab = 'survey'">
          {{ $t("survey.text") }}
        </div>
      </nav>

      <div class="tab-content">
        <div :class="{ active: activeTab === 'questionset' }">
          <OrganizationQuestionSet></OrganizationQuestionSet v-if="activeTab === 'questionset'">
        </div>
        <div :class="{ active: activeTab === 'survey' }">
          <OrganizationSurveyTemplate v-if="activeTab === 'survey'"></OrganizationSurveyTemplate>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationQuestionSet from "../question/organization-question-set.vue";
import OrganizationSurveyTemplate from "../survey/organization-survey-template.vue";

export default {
  props: ["scope", "product"],

  components: { OrganizationSurveyTemplate, OrganizationQuestionSet },
  data() {
    return {};
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationQuestionSetAndSurvey/selectedTab"];
      },
      set(v) {
        this.$store.commit("organizationQuestionSetAndSurvey/selectedTab", v);
      },
    },
    hasOrganizationQuestionSetViewPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_ADMIN",
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },

  },

  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../question/question-set.scss";

.tab-content > div {
  display: none;
  padding-top: 1rem;

  &.active {
    display: block;
  }
}

</style>
